import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SetAppLockActivatedRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SetAppLockActivatedResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const setAppLockActivated = (request: SetAppLockActivatedRequest, options?: CashRequestOptions) =>
  post<SetAppLockActivatedRequest, SetAppLockActivatedResponse>('/2.0/cash/set-app-lock-activated', request, {
    ...options,
    rejectOnError: true,
  })
